import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
// 引入 Element UI 组件和样式
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 修复：改回兼容所有版本的引入方式（删除xlsx.mini的错误路径）
import * as XLSX from 'xlsx'
Vue.prototype.$XLSX = XLSX

// 注册 Element UI + 全局配置（保留之前的v-loading修复配置，核心解决加载卡死）
Vue.use(ElementUI, {
  loading: {
    fullscreen: true,
    lock: false, // 关键：关闭遮罩锁定，确保loading能正常关闭
    text: '数据加载中...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.3)'
  },
  message: {
    showClose: true,
    duration: 2000
  }
})

Vue.config.productionTip = false
// 核心：开启异步更新，解决v-loading状态同步阻塞
Vue.config.async = true
// 全局容错版$nextTick，确保loading关闭指令必执行
Vue.prototype.$safeNextTick = function (callback) {
  return this.$nextTick(callback).catch(err => {
    console.warn('$nextTick执行异常：', err)
    if (typeof callback === 'function') callback()
  })
}

// 推荐挂载方式，兼容DOM加载顺序
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')